module.exports = __webpack_public_path__ + "assets/img/781587008304_.pic_hd.8b592c84.jpg";